import N8nInfoAccordion from './InfoAccordion.vue';

export default N8nInfoAccordion;
